


















import Vue from 'vue'
import { RouteConfig, Route } from 'vue-router'
// import { UAParser } from 'ua-parser-js'
import store from '@/store'
import Logo from '@/components/globals/logo.vue'

type video = HTMLVideoElement | undefined

export default Vue.extend ({
  data() {
    return {
      isMobile: store.state.isMobile,
      isSafari: false,
      isPlaying: false,
      video: undefined as video
    }
  },
  
  components: {
    Logo
  },

  created() {
    // const uaParser = new UAParser()
    // const isSafari = uaParser.getBrowser().name === 'Safari'
    // if (isSafari) this.isSafari = true
  },

  mounted() {
    this.video = this.$refs.video as HTMLVideoElement
  },

  beforeRouteLeave(to, from , next) {
    if (this.isMobile) {
      next()
    } else {
      (this.video as HTMLVideoElement).play();
      (this.video as HTMLVideoElement).addEventListener('ended', () => next())
       // @ts-ignore
      // if (this.isSafari) this.video.addEventListener('play', () => setTimeout(() => this.isPlaying = true, 500))
    }
  }
})
